<template>
	<view class="box">
		<view class="item" @click="jumpService(4)">
			<text>《用户服务协议》</text>
			<image src="/static/icon/ic_ar2@2x.png" mode="widthFix"></image>
		</view>
		<view class="item" @click="jumpService(5)">
			<text>《用户隐私协议》</text>
			<image src="/static/icon/ic_ar2@2x.png" mode="widthFix"></image>
		</view>
		<view class="item" @click="show = true">
			<text>注销账号</text>
			<image src="/static/icon/ic_ar2@2x.png" mode="widthFix"></image>
		</view>
		<!-- 注销提醒 -->
		<u-popup :show="show" round="15" :safeAreaInsetBottom="false" mode="center">
			<view class="tc">
				<view class="tc-contemt">
					<view class="tc-contemt-title">注销提醒</view>
					<view class="tc-contemt-nr">
						如您不再使用此账号，可以将其注销。账号成功注销后，其下所有数据将会被删除并将无法恢复，请谨慎操作
					</view>
				</view>
				<view class="tc-btn">
					<view class="tc-btn-item" @click="show = false">我再想想</view>
					<view class="tc-btn-item" style="color: #E4001D;" @click="loginOut()">确认注销</view>
				</view>
			</view>
		</u-popup>
	</view>
</template>

<script>
	export default {
		data() {
			return {
				show: false
			};
		},
		methods: {
			jumpService(flag) {
				uni.navigateTo({
					url: '/pagesA/pages/rich-text-page/rich-text-page?flag='+flag
				})
			},
			loginOut() {
				this.$u.api.logOff()
					.then(res => {
						if (res.code == 200) {
							uni.showToast({
								title:'账号注销成功',
								icon:'success'
							})
							uni.$emit('loginOut')
							this.$store.commit('clear')
							uni.switchTab({
								url: '/pages/index/index'
							})
						}
					})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.box {
		width: 100%;
		padding: 0 30rpx;
		box-sizing: border-box;
		.tc {
			width: calc(100vw - 148rpx);
			.tc-btn {
				width: 100%;
				height: 102rpx;
				display: flex;
				align-items: center;
				justify-content: space-between;
				border-top: 1rpx solid #EEEEEE;
				.tc-btn-item {
					flex: 1;
					height: 100%;
					display: flex;
					align-items: center;
					justify-content: center;
					font-weight: 400;
					font-size: 32rpx;
					color: #666666;
					border-right: 1rpx solid #EEEEEE;
					&:last-child {
						border: none !important;
					}
				}
			}
			.tc-contemt {
				width: 100%;
				padding: 40rpx 0;
				box-sizing: border-box;
				display: flex;
				align-items: center;
				justify-content: center;
				flex-direction: column;
				.tc-contemt-title {
					width: 100%;
					text-align: center;
					font-weight: 600;
					font-size: 32rpx;
					color: #111111;
				}
				.tc-contemt-nr {
					width: 472rpx;
					text-align: center;
					font-weight: 400;
					font-size: 28rpx;
					color: #333333;
					margin-top: 40rpx;
				}
			}
		}
		.item {
			width: 100%;
			height: 102rpx;
			display: flex;
			align-items: center;
			justify-content: space-between;
			border-bottom: 1rpx solid #E5E5E5;
			text {
				font-weight: 400;
				font-size: 30rpx;
				color: #222222;
			}
			image {
				width: 14rpx;
				height: 28rpx;
			}
		}
	}
</style>